import { ContainerPadding, Text, TextAlignment, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { useCallback, useEffect } from 'react';
import { LettersInput } from '../../../components/inputs-group/inputs/letters-input';
import { TelefonoInput } from '../../../components/inputs-group/inputs/telefono-input';
import { LegalesSection } from '../../../components/inputs-group/legales-section';
import { InputsGroup } from '../../../components/screen/inputs-group';
import { Section } from '../../../components/screen/section';
import { ThankyouScreen } from '../../../components/screen/thankyou';
import { FIELD_NAME } from '../../../constants/form-constants';
import { useApp } from '../../../contexts/app-context';
import { personEntity } from '../../../entities/person-entity';
import { vehicleEntity } from '../../../entities/vehicle-entity';
import { formService } from '../../../form-service';
import { isComerciales } from '../../../helpers/carline-helpers';
import { getParamsForm } from '../../../helpers/form-helpers';
import { getLeadVentaProductData } from '../lead-venta-product-data';
import { CallMeConsentimientosEnvioSection } from './call-me-consentimientos-envio-section';

export const CallMeForm = () => {
	const { setAppThankyouScreen } = useApp();

	const getFormData = useCallback(() => {
		const { url } = getParamsForm();

		return {
			brand: isComerciales() ? 'N' : 'V',
			name: personEntity.name,
			prefix: personEntity.phonePrefix,
			cellphone: personEntity.phone,
			lssi: formService.getFieldValue(FIELD_NAME.RGPD_COMUNICACIONES_COMERCIALES) || 'NO INFORMADO',
			tmk: formService.getFieldValue(FIELD_NAME.RGPD_PERFILADO) || 'NO INFORMADO',
			ref: url,
			carlineCode: vehicleEntity.carlineCode,
			ofertaId: vehicleEntity.ofertaId,
		};
	}, []);

	const Form = () => (
		<>
			<Section paddingBottom={ContainerPadding.static515}>
				<Text bold appearance={TokenTextAppearance.headline200}>
					Para llamarte, necesitamos tus datos de contacto
				</Text>
				<Text appearance={TokenTextAppearance.copy200}>
					Nos pondremos en contacto contigo de lunes a viernes de 9:00 h a 19:30 h (excepto festivos nacionales) para
					darte más información.
				</Text>
				<InputsGroup>
					<LettersInput name={FIELD_NAME.NAME} required />
					<TelefonoInput required />
				</InputsGroup>
			</Section>
			<CallMeConsentimientosEnvioSection formData={getFormData} showComunicacionesComerciales />
			<LegalesSection />
		</>
	);

	const CustomThankyou = () => {
		return (
			<ThankyouScreen
				title={
					<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center} bold>
						{isComerciales() ? '¡Muchas gracias por tu interés!' : 'Te llamaremos muy pronto'}
					</Text>
				}
				text={
					<Text appearance={TokenTextAppearance.copy100} textAlign={TextAlignment.center}>
						{isComerciales() ? 'En breve te llamaremos desde un número terminado en 904.' : ''}
					</Text>
				}
			/>
		);
	};

	useEffect(() => {
		//setAppLoading(true);
		setAppThankyouScreen(<CustomThankyou />);

		getLeadVentaProductData().then(() => {
			//setAppLoading(false);
		});
	}, []);

	return Form();
};
